import React, { Component } from 'react';
import DataTableCell from "./DataTableCell";

export default class DataTableHeader extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <tr style={{
                backgroundColor: this.props.index % 2 ? this.props.option.backgroundColorBody1 : this.props.option.backgroundColorBody2,
            }}>
                {
                    this.props.columns.map((c, i) => (
                        <DataTableCell key={i} column={c} row={this.props.row} rows={this.props.rows} index={i} option={this.props.option} />
                    ))
                }
            </tr>
        );
    }
}
